var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeadset = function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.939 10.109A2 2 0 0 1 22 11.875v1.25a2 2 0 0 1-1 1.732V17a4 4 0 0 1-4 4h-2.268A2 2 0 0 1 11 20a2 2 0 0 1 3.732-1H17a2 2 0 0 0 2-2v-1.875h-1V16h-2V9h2v.875h.884C18.281 6.507 15.4 4 12 4S5.719 6.507 5.116 9.875H6V9h2v7H6v-.875H4a2 2 0 0 1-2-2v-1.25a2 2 0 0 1 1.061-1.767C3.585 5.543 7.387 2 12 2s8.415 3.543 8.939 8.108",
    clipRule: "evenodd"
  })));
};
export default SvgHeadset;